import TagManager from "react-gtm-module";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}

type tagManagerArgs = {
  dataLayer: {
    event: string;
    nome_do_evento: string;
    acao: object | string | undefined;
    rotulo?: any;
  };
};

export function handlerDatalayer(tagManagerArgs: tagManagerArgs): void {
  TagManager.dataLayer(tagManagerArgs);
}

export function handlerOpenUrl(
  data: tagManagerArgs,
  handleGoNextPage: (pathname: string, search?: string, state?: any) => void,
  dataRouter: any,
  isRouter: boolean
): void {
  handlerDatalayer(data);

  if (isRouter) {
    handleGoNextPage(
      dataRouter.pathname,
      dataRouter?.search,
      dataRouter?.state
    );
  } else {
    window.open(dataRouter.pathname, "_self");
  }
}
